// extracted by css-extract-rspack-plugin
export default {"EditProfileLayer":"src-shared-components-MainLayout-components-UserProfile-components-EditProfileLayer-EditProfileLayer-module__EditProfileLayer-KZvDvl","editProfileLayer":"src-shared-components-MainLayout-components-UserProfile-components-EditProfileLayer-EditProfileLayer-module__EditProfileLayer-KZvDvl"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"EditProfileLayer\":\"src-shared-components-MainLayout-components-UserProfile-components-EditProfileLayer-EditProfileLayer-module__EditProfileLayer-KZvDvl\",\"editProfileLayer\":\"src-shared-components-MainLayout-components-UserProfile-components-EditProfileLayer-EditProfileLayer-module__EditProfileLayer-KZvDvl\"}";
        // 1793872698105
        var cssReload = require("../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  